
<template>
  <!-- 对login.vue进行的优化 -->
  <div v-if="show">
    <!-- 微信登录 绑定手机号 -->
    <div v-if="isWx && uid == '0'">
      <div class="login login-shadow">
        <!-- <img @click="close" src="@/assets/img/dianbo/close.png" alt /> -->
      </div>
      <div class="login login-box">
        <!-- <img v-if="closeable" class="img-close" @click="close" src="@/assets/img/base/close.png" alt /> -->

        <img class="logo" src="@/assets/img/base/gkztc_logo_big.png" />
        <div v-if="title" class="title">{{ title }}</div>
        <div class="phone input-box">
          <input type="text" placeholder="手机号" v-model="mobile" />
        </div>
        <div class="code input-box">
          <input type="text" placeholder="验证码" v-model="verifycode" />
          <span :class="codeText !== '发送验证码' ? 'gray' : ''" @click="sendCode">{{codeText}}</span>
        </div>
        <div class="login-btn canpress" @click="login">提交</div>
      </div>
    </div>

    <div v-else>
      <div class="login login-shadow">
        
      </div>
      <div class="login login-box">
        <img v-if="closeable" class="img-close" @click="close" src="@/assets/img/base/close.png" alt />
        <img class="logo" src="@/assets/img/base/gkztc_logo_big.png" />
        <div v-if="title" class="title">{{ title }}</div>
        <div class="phone input-box">
          <input type="text" placeholder="手机号" v-model="mobile" />
        </div>
        <div class="code input-box">
          <input type="text" placeholder="验证码" v-model="verifycode" />
          <span :class="codeText !== '发送验证码' ? 'gray' : ''" @click="sendCode">{{codeText}}</span>
        </div>
        <div v-show="mobile&&verifycode" class="login-btn canpress" @click="login">登录</div>
        <div v-show="!(mobile&&verifycode)" class="login-btn" >立即登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import Http from "utils/fetchDefault/fetch";
import initCompate from "utils/compatibility"
import checkAppVersion from "utils/checkAppVersion"
import {
  DEFAULT_SENDRANDOMCODE,
  DEFAULT_LOGIN_BY_VCODE,
  OAUTH2_TOKEN,
  WX_ACCESSTOKEN,
  DEFAULT_WX_REGISTER,
  DEFAULT_SEND_REG_RANDOM_CODE,
  DEFAULT_LOGINID,
  USER_VIEW
} from "utils/api";
import hex_md5 from "utils/md5";
import Cookie from "utils/cookie";
import { Toast } from 'vant';
import { setLocalToken, getLocalToken, setLocalUid, getLocalUid, clearLocalToken, getCookieToken, getCookieUid } from '@/utils/token.js'

export default {
  name: "loginNew",
  // props: ["show"],
  props: {
    closeable: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      //登录
      show: false,
      isWx: false, //微信环境
      isMiniprogram:false, //小程序环境
      mobile: "",
      verifycode: "",
      codeText: "发送验证码",
      openId: "",
      uid: "",
      // loginInfo: this.$store.getters.loginInfo,
      // callback:null,
    };
  },
  computed: {
    loginInfo(){
      return this.$store.getters.loginInfo
    },
    userInfo(){
      return this.$store.getters.userInfo
    }
  },
  created() {
    this.isWx = this.isWeixin();
    this.isMiniprogram = this.checkMiniprogram()
    window.getAppToken = this.getAppToken;
    console.log('isWx: ' + this.isWx)
    console.log('isMiniprogram: ' + this.isMiniprogram)
    this.loginInit()
  },
  mounted() {
  },
  methods: {
    /**
     * 登录完成回调
     * @param {Boolean} islogin 登录成功true，失败false
     */
    async logined(islogin){
      this.$emit("logined",islogin)
      if(islogin&&!this.userInfo.nickname){
        try {
          // 获取登录信息并放到vuex
          let data = await this.getUserInfo(this.loginInfo.uid,this.loginInfo.access_token)
          console.log('view userInfo', data)
          const defaultUserInfo = {
            nickname: '',
            profile_image_url: '',
            appadmin:'',
          }
          this.$store.commit("setUserInfo", Object.assign(defaultUserInfo, data));
        } catch (error) {
          console.log(error);
          localStorage.removeItem('loginInfo')
          localStorage.removeItem('uid')
          this.$store.commit("setLoginInfo", {
              access_token: '',
              uid: '',
          });
          Cookie.deleteCookie("access_token", ';domain=gaokaozhitongche.com') 
          Cookie.deleteCookie("user_id", ';domain=gaokaozhitongche.com') 
          this.toLogin()
        }
      }
    },
    /**
     * 项目内回调，
     * 调用的前提：localStorage 必须存有 有效的 loginInfo 和 uid（因为旧版登录一定会用到localStorage里的信息，所以不论如何也要保证本地缓存里有登录信息
     * 注意：loginNew组件的【页面】回调一律由logined去执行！
     * 简介：该方法用于从缓存（旧版存在缓存）获取登录信息，并存入vuex（新版存在vuex），cookie（兼容XGK接口）
     * 以后如果又有哪个登录，需要把登录信息存在什么奇怪的地方，就直接在这里进行处理！
     */
    callback() {
      var loginInfo = localStorage["loginInfo"];
      if (loginInfo) {
        loginInfo = JSON.parse(loginInfo);
        this.$store.commit("setLoginInfo", {
          access_token: loginInfo.access_token,
          uid: localStorage["uid"],
        });
        // 从7.7.1开始 app 设置了
        if(checkAppVersion('7.7.1') < 0 || !this.inApp()) {
          Cookie.setCookie("access_token",  loginInfo.access_token, 30, ';domain=gaokaozhitongche.com') // 兼容gaokaozhitongche主域名的页面登录
          Cookie.setCookie("user_id",  localStorage["uid"], 30, ';domain=gaokaozhitongche.com') // 兼容gaokaozhitongche主域名的页面登录
        }
        // Cookie.setCookie("access_token",  loginInfo.access_token, 30, ';domain=gaokaozhitongche.com') // 兼容gaokaozhitongche主域名的页面登录
        this.logined(true)
      }else{
        this.logined(false)
      }
    },
    /**
     * 初始化，会在组件created周期调用，唯一初始化入口
     */
    async loginInit(){
      console.log('initLogin')
      // 判断vuex里有登录信息，就直接回调登录成功
      //（也就是说，所有登录方式最后都必须调用统一的存入方法callback，把登录信息存入vuex，否则会出现重复登录的情况，
      if(this.loginInfo.uid > 0){
        this.logined(true)
        return
      }
      // ---------- 判断vuex里没有登录信息
      // App端 不需要我们唤起登录
      if(this.inApp()) return;
      // 小程序端 会在url里带上token
      if(this.isMiniprogram){
        // 小程序环境，获取小程序登录信息
        if(this.$route.query.token||this.$route.query.access_token){
          // 复制cookie前，删除openId
          Cookie.deleteCookie("openId");
          Cookie.deleteCookie("openId", ';domain=' + document.domain);
          Cookie.deleteCookie("openId", ';domain=gaokaozhitongche.com');
          Cookie.setCookie("openId", this.$route.query.openid, 30, ';domain=gaokaozhitongche.com');
          this.getAppToken(this.$route.query.token?this.$route.query.token:this.$route.query.access_token)
        } else if (Cookie.getCookie("access_token")) {
          console.log(Cookie.getCookie("access_token"))
          this.getAppToken(Cookie.getCookie("access_token"))
        }
        return
      }
      // 调用checkIsLogin判断是否已经登录过
      let isLogin = await this.checkIsLogin()
      // 这里似乎没有去判断登录信息，找个时间排查一下
      if(this.isWx){
        this.toLogin()
        return
      }
      console.log('loginInit', isLogin)
      // 登录信息有效
      if(isLogin){
        this.callback()
        // callback已经做了这件事
        // 判断缓存有后，存入vuex。所以每个页面都要有这个方法 
        // var loginInfo = localStorage["loginInfo"];
        // if (loginInfo) {
        //   loginInfo = JSON.parse(loginInfo);
        //   this.$store.commit("setLoginInfo", {
        //       access_token: loginInfo.access_token,
        //       uid:localStorage["uid"],
        //   });
        //   this.logined(true)
        // }else{
        //   this.logined(false)
        // }
      }else{
        // 登录信息失效，清除缓存信息，回调false（在页面上的logined回调再去唤起登录弹窗或者进行其他操作
        localStorage.removeItem('loginInfo')
        localStorage.removeItem('uid')
        this.$store.commit("setLoginInfo", {
            access_token: '',
            uid: '',
        });
        Cookie.deleteCookie("access_token", ';domain=gaokaozhitongche.com') 
        Cookie.deleteCookie("user_id", ';domain=gaokaozhitongche.com') 
        this.logined(false)
      }
    },
    // 切记 不能用async ，因为iOS的高考直通车app 不兼容这个写法，会调两次
    // 从App获得token，并通过接口获得uid，存入vuex，目前就只有App端是拿不到token和uid以外的信息的
    getAppToken(token) {
      //app内
      console.log("apptoken2",token);
      // this.getUid(token, (uid) => {
      //   if(uid>0){
      //     this.$store.commit("setLoginInfo", {
      //       access_token: token,
      //       uid: uid,
      //     });
      //     this.logined(true)
      //   }else{
      //     this.logined(false)
      //   }
      // })
      this.getUid(token).then(uid => {
        if(uid>0){
          // 如果通过app返回的token正确拿到了uid，就放进缓存并给callback去处理
          localStorage["loginInfo"] = JSON.stringify({
            access_token: token
          })
          localStorage['uid'] = uid
          this.callback()
          // this.$store.commit("setLoginInfo", {
          //   access_token: token,
          //   uid: uid,
          // });
          // this.logined(true)
        }else{
          this.logined(false)
        }
      })
    },
    /**
     * 登录成功后，用token和uid获得用户信息
     * @param {*} uid 
     * @param {*} token 
     */
    getUserInfo(uid,token){
      return new Promise((resolve, reject)=>{
        Http.get(USER_VIEW, {
            access_token: token,
            uid: uid
        }).then((res) => {
          if (res.code == 0) {
            resolve(res.data.item)
          }else if(res.code == 20030) {
            // localStorage.removeItem('loginInfo')
            // localStorage.removeItem('uid')
            // this.$store.commit("setLoginInfo", {
            //     access_token: '',
            //     uid: '',
            // });
            // this.logined(false)
            reject('')
          }else{
            reject('')
          }
        }).catch((err) =>{
            reject('')
        });
      })
    },
    getUid(token, cb){
        // Http.get(DEFAULT_LOGINID, {
        //     access_token: token,
        // }).then((res) => {
        //     if (res.code == 0) {
        //         cb(res.data.uid)
        //     }else{
        //         cb('')
        //     }
        // }).catch(err=>{
        //     cb('')
        // });
        return Http.get(DEFAULT_LOGINID, {
          access_token: token,
        }).then((res) => {
          if (res.code == 0) {
            return Promise.resolve(res.data.uid)
          }else{
            return Promise.resolve('')
          }
        }).catch(err=>{
          return Promise.resolve('')
        });
    },
    inApp(){
        var ua = navigator.userAgent.toLowerCase()
        if(ua.indexOf('gkztc')> -1){
            return true
        }else{
            return false
        }
    },
    /**
     * 主动登录方法
     * 获取登录信息失败后，可以由页面去调用。在组件里，获取用户信息失败或者微信登录也会被动去调用
     * @param {*} callback 登录后的组件内回调，this.callback 中调用，this.callback主要是微信登录要用到。在页面里一般用logined回调足矣
     * @param {*} isCloseWxLg 
     */
    async toLogin(callback,isCloseWxLg) {
      console.log('调了toLogin')
      // app登录
      if(this.inApp()){
        // this.checkIsLogin()
          location.href = "gkztc://site/login/";
          return
      }
      // 登录回调，更新缓存数据到vuex，目前是
      // this.callback = () =>{
      //   var loginInfo = localStorage["loginInfo"];
      //   if (loginInfo) {
      //     loginInfo = JSON.parse(loginInfo);
      //     this.$store.commit("setLoginInfo", {
      //       access_token: loginInfo.access_token,
      //       uid:localStorage["uid"],
      //     });
      //     this.logined(true)
      //   }else{
      //     this.logined(false)
      //   }
      //   callback&&callback()
      // },
      //需要登录时调用此方法  登录信息将保存到 localStorage["loginInfo"]
      // let isLogin = await this.checkIsLogin(isCloseWxLg)
      // console.log('isLogin', isLogin)
      // debugger
      // if(!isLogin){
      //   if (this.isWx&&!isCloseWxLg) {
      //     this.wxLogin();
      //   } else {
      //     this.isWx = false
      //     this.showLoginBox()
      //   }
      // }
      console.log(123, this.isWx, isCloseWxLg)
      if (this.isWx&&!isCloseWxLg) {
        // 微信登录
        this.wxLogin();
      } else {
        // h5登录 或者 不需要微信登录的h5
        this.isWx = false
        this.showLoginBox()
      }
      
    },
    /**
     * 获取localStorage里的登录信息判断是否登录过 async 函数
     * 注意：这个方法千万不要用页面去调用（老方法有这么用但是不建议），因为loginNew登录信息的处理在callback方法，如果你只是怕登录信息已经存在缓存，那可以不用担心，loginInit会主动走这一步（App和小程序不会调用到，但是他们本身就没有在h5页面留下他们token过期信息）
     * 虽然vuex刷新后会失去，但是会在这里进行判断是否在缓存有登录信息
     * @param {*} isCloseWxLg 
     * @return {Boolean} 如果缓存没有登录信息，返回false，如果缓存存在登录信息且没过期，返回true，过期则同步调用刷新接口并返回true
     */
    async checkIsLogin(isCloseWxLg) {
      var loginInfo = localStorage["loginInfo"];
      var uid = localStorage["uid"];
      // 如果是微信端，且cookie里没有openId，也是登录失效了
      if(!isCloseWxLg&&this.isWx){
        var openid = Cookie.getCookie("openId");
        if(!openid){
          console.log('openid nono')
          return false
        }
      }
      if (this.getCookieInfo()) {
        // loginInfo 设置留空的信息
        const obj = {
          "access_token": getCookieToken(),
          "expires_in": parseInt(new Date().getTime() / 1000) + 43200,
          "scope": "default",
          "token_type": "Bearer",
          "refresh_token": "",
          "code": 0,
          "msg": ""
        }
        localStorage["loginInfo"] = JSON.stringify(obj)
        loginInfo = JSON.stringify(obj)
        localStorage["uid"] = getCookieUid()
        uid = getCookieUid()
        return true
      }
      console.log('checkIsLogin 登录信息', loginInfo, uid)
      // 如果缓存存在登录信息
      if (loginInfo && uid>0) {
        loginInfo = JSON.parse(loginInfo);
        var time = parseInt(new Date().getTime() / 1000);
        console.log('checkIsLogin token有效期', time, loginInfo.expires_in)
        // 当前时间小于过期时间就是有效
        if (time < loginInfo.expires_in) {
          console.log('token没有过期')
          // 没过期就把缓存里的放进vuex // 二次修改，这件事已经由callback做了，checkIsLogin后的操作
          // this.$store.commit("setLoginInfo", loginInfo);
          console.log('this.loginInfo', this.loginInfo)
          // if(!isCloseWxLg&&this.isWx){
          //   await this.refreshToken(loginInfo.refresh_token)
          // }else if(time > loginInfo.expires_in-24*60*60){
          //   await this.refreshToken(loginInfo.refresh_token)
          // }
          return true;
        } else {
          // 如果刷新成功就返回true
          return await this.refreshToken(loginInfo.refresh_token)
          // return true;
        }
      } else {
        return false;
      }
    },
    // 刷新token
    /**
     * token过期时，刷新token
     * 该方法不主动调用callback，只负责刷新token，调用过refreshToken的地方是checkIsLogin，确认登录后会调用callback存储登录信息
     * @param {*} refresh_token 
     */
    refreshToken(refresh_token) {
      return new Promise((resolve, reject) =>{
        var uid = localStorage["uid"];
        Http.post(OAUTH2_TOKEN, {
          client_id: "gkztcweb",
          client_secret: "web4gkztc",
          grant_type: "refresh_token",
          uid: uid,
          refresh_token: refresh_token
        }).then(res => {
          console.log('refreshToken', res)
          // debugger
          if (res.code == 0) {
            // callback(res.data.access_token);
            var data = res.data
            data.expires_in = parseInt(new Date().getTime() / 1000) + res.data.expires_in;
            localStorage["loginInfo"] = JSON.stringify(data);
            // this.$store.commit("setLoginInfo", data); // this.callback做了这件事
            // this.callback(); // 
            resolve(true);
          } else {
            // refreshToken 也有过期的可能
            resolve(false);
          }
        }).catch(err => {
          resolve(false);
        })
      })
      
    },
    isWeixin() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("micromessenger") != -1;
    },
    checkMiniprogram(){
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("miniprogram") != -1||ua.indexOf("alipayclient") != -1;
    },
    randomString(len) {
      len = len || 42;
      var $chars =
        "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = "";
      for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    /**
     * 
     */
    setLoginInfo() {

    },
    // ----------------------------- 组件交互方法 --------------------------------
    // 验证码登录
    login() {
      if (this.mobile == "" || this.mobile.trim().length != 11) {
        Toast({
          message: "请输入11位的手机号",
          className: 'login-toast'
        });
        return;
      }
      if (this.verifycode == "") {
        Toast({
          message: "请输入验证码",
          className: 'login-toast'
        });
        return;
      }
      // 微信端唤起验证码只有一种情况，就是注册/第一次绑定微信和app账号
      if (this.isWx) {
        var data = {
          // access_token: this.loginInfo.access_token,
          openid: this.openId,
          verifycode: this.verifycode,
          mobile: this.mobile
        };
        // console.log(data);
        // this.uploading = this.$loading({
        //     background: 'rgba(0, 0, 0, 0.6)'
        // })
        Toast.loading({
          duration: 0,
          message: "加载中...",
          forbidClick: true,
          className: 'login-toast'
        });
        Http.post(DEFAULT_WX_REGISTER, data).then(res => {
          // console.log("register", res);
          // this.uploading.close()
          if (res.code == 0) {
            Toast.clear()
            this.show = false;
            localStorage['userInfo'] = JSON.stringify(res.data.item)
            localStorage['uid'] = res.data.item.id

            const token = res.token
            token.expires_in = parseInt(new Date().getTime() / 1000) + res.token.expires_in;
            localStorage["loginInfo"] = JSON.stringify(token);
            // localStorage["loginInfo"] = JSON.stringify(this.loginInfo);

            this.$message({
              type:'success',
              message: "绑定成功"
            });
            this.callback&&this.callback();
          }
        }).catch(error=>{
          // this.uploading.close()
          // Toast.clear()
        });
      } else {
        var data = {
          access_token: this.loginInfo.access_token,
          verifycode: this.verifycode,
          ostype: "0", //（0默认1安卓2苹果3web4微信5小程序）
          mobile: this.mobile
        };
        // this.uploading = this.$loading({
        //     background: 'rgba(0, 0, 0, 0.6)'
        // })
        Toast.loading({
          duration: 0,
          message: "加载中...",
          forbidClick: true,
          className: 'login-toast'
        });
        Http.post(DEFAULT_LOGIN_BY_VCODE, data).then(res => {
          // console.log(res);
          // this.uploading.close()
          if (res.code == 0) { 
            Toast.clear()
            this.show = false;
            
            localStorage['userInfo'] = JSON.stringify(res.data.item)
            localStorage['uid'] = res.data.uid
            // 更新 loginInfo
            // this.loginInfo = Object.assign(this.loginInfo, res.token)
            // this.$store.commit("setLoginInfo", {
            //     access_token: res.token.access_token,
            //     uid: res.data.uid,
            // });

            const token = res.token
            token.expires_in = parseInt(new Date().getTime() / 1000) + res.token.expires_in;
            // this.$store.commit("setLoginInfo", token); // callback做了这件事
            localStorage["loginInfo"] = JSON.stringify(token);

            this.$message({
              type:'success',
              message: "登录成功"
            });
            this.callback&&this.callback();
          }
        }).catch(error=>{
          // this.uploading.close()
          // Toast.clear()
        });
      }
    },
    sendCode() {
      if (this.codeText != "发送验证码") {
        return;
      }
      if (this.mobile == "" || this.mobile.trim().length != 11) {
        Toast({
          message: "请输入11位的手机号",
          className: 'login-toast'
        });
        return;
      }

      if (this.isWx) {
        var data = {
          // access_token: this.loginInfo.access_token,
          mobile: this.mobile,
          type: 1,
          category: 1,
          // ver: 1.1,
          // chksign: hex_md5(
          //   this.loginInfo.access_token + "g2k0z1t0c" + this.mobile
          // )
        };
        // console.log(data);
        //  this.uploading = this.$loading({
        //   background: 'rgba(0, 0, 0, 0.6)'
        // })
        Toast.loading({
          duration: 0,
          message: "加载中...",
          forbidClick: true,
          className: 'login-toast'
        });
        Http.post(DEFAULT_SENDRANDOMCODE, data).then(res => {
          // console.log(res);
          // this.uploading.close()
          if (res.code == 0) {
            Toast.clear()
            var count = 60;
            this.codeText = "还有" + count + "秒";
            var timer = setInterval(() => {
              count--;
              if (count == 0) {
                this.codeText = "发送验证码";
                clearInterval(timer);
              } else {
                this.codeText = "还有" + count + "秒";
              }
            }, 1000);
          }
        }).catch(error=>{
          // this.uploading.close()
          // Toast.clear()
        });
      } else {
        // this.getLoginInfo(this.sendRandomCode); // v1逻辑要先获得token，v2不再需要
        this.sendRandomCode()
      }
    },
    sendRandomCode(loginInfo) {
      // this.uploading = this.$loading({
      //   background: 'rgba(0, 0, 0, 0.6)'
      // })
      Toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true,
        className: 'login-toast'
      });
      var data = {
        // access_token: loginInfo.access_token,
        mobile: this.mobile,
        type: "1", //1短信 2语音
        category: "13", //1注册2忘记密码11身份验证 12手机号变更13验证码登录）
        ver: "1",
        // chksign: hex_md5(loginInfo.access_token + "g2k0z1t0c" + this.mobile) //MD5加密后的字段 ($access_token + 'g2k0z1t0c' + $mobile)
      };
      Http.post(DEFAULT_SENDRANDOMCODE, data).then(res => {
        // console.log(res);
        // this.uploading.close();
        if (res.code == 0) {
          Toast.clear()
          var count = 60;
          this.codeText = "还有" + count + "秒";
          var timer = setInterval(() => {
            count--;
            if (count == 0) {
              this.codeText = "发送验证码";
              clearInterval(timer);
            } else {
              this.codeText = "还有" + count + "秒";
            }
          }, 1000);
        }
      }).catch(error=>{
        // this.uploading.close();
        // Toast.clear()
      });
    },
    // 展示登录弹窗
    showLoginBox(){
      this.show = true;
      setTimeout(() =>{
        initCompate();
      },300)
    },
    close() {
      this.show = false;
    },
    // 已经弃用的方法v1逻辑要先获得token，v2不再需要
    // getLoginInfo(callback) {
    //   Http.post(OAUTH2_TOKEN, {
    //     client_id: "gkztcweb",
    //     client_secret: "web4gkztc",
    //     grant_type: "client_credentials",
    //     uid: "",
    //     refresh_token: ""
    //   }).then(res => {
    //     if (res.code == 0) {
    //       var data = res.data;
    //       data.expires_in =
    //         parseInt(new Date().getTime() / 1000) + res.data.expires_in;
    //       // this.loginInfo = data;
    //       this.$store.commit("setLoginInfo", data);
    //       // localStorage["loginInfo"] = JSON.stringify(data);
    //       // callback(res.data.access_token,this.getCode());
    //       callback(data);
    //     }
    //   });
    // },
    // ----------------------------- 微信登录方法 --------------------------------
    // 微信授权登录
    wxLogin() {
      if (!this.checkExpires()) {
        // this.getToken(this.checkCode)
        this.checkCode();
      } else {
        console.log("你已经登录过了");
        // checkExpires 已经校验过了缓存信息，所以直接调用没关系
        this.callback()
      }
      // this.getToken(this.checkCode);
    },
    // 微信 检查登录信息，并从缓存更新到vuex
    checkExpires() {
      var openid = Cookie.getCookie("openId");
      if (!openid) {
        return false;
      }
      var loginInfo = localStorage["loginInfo"];
      var uid = localStorage["uid"];
      if (loginInfo&&uid>0) {
        loginInfo = JSON.parse(localStorage["loginInfo"]);
        // this.loginInfo = loginInfo;
        // 不用更新vuex也行，因为 this.callback 负责将token从缓存获取存入vuex 
        var dateTime = parseInt(new Date().getTime() / 1000);
        if (dateTime < loginInfo.expires_in) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // function getOpenid(){
    //     const oid = Cookie.getCookie("openId");
    //     if(oid==="")  return false;
    //     return oid;
    // }
    checkCode() {
      if (this.getCode()) {
        console.log("hascode", this.getCode());
        // return
        this.getWxToken(this.getCode())
        // this.getToken(this.getWxToken);
        // this.getWxToken(token, this.getCode());
      } else {
        console.log("nocode");
        this.getWxcode();
      }
    },
    // 通过code获取token
    getWxToken(code) {
      var _this = this;
      console.log(code);
      Http.post(WX_ACCESSTOKEN, {
        code: code,
        // ...getHeaderInfo()
      }).then(res => {
        console.log('getWxToken', res)
        // debugger
        if (res.code == 0) {
          var data = res.data;
          // console.log("data", data);

          // 更新登录信息
          var token = res.token
          token.expires_in = parseInt(new Date().getTime() / 1000) + res.token.expires_in;
          // this.$store.commit("setLoginInfo", {
          //   access_token: token.access_token,
          //   uid: data.uid
          // }); // callback已经做了这件事
          // 存入缓存
          localStorage["loginInfo"] = JSON.stringify(token);

          if (data.openid) {
            Cookie.setCookie("openId", data.openid, 30, ';domain=gaokaozhitongche.com');
            _this.openId = data.openid;
          }
          if (data.uid) {
            Cookie.setCookie("uid", data.uid);
            localStorage['uid'] = data.uid;
          }
          _this.uid = data.uid;
          // _this.uid = 0;
          console.log("uiduid", _this.uid);
          // 如果是新用户就展示注册弹窗
          if (_this.uid == "0") {
            _this.showLoginBox()
          }else{
            // 老用户直接处理登录信息
            this.callback()
          }
        } else if (res.code === 10001){
          this.getWxcode();
          // invalid code code失效，需要再刷新拿一次
        }
      });
    },
    // 跳转授权中转页，获得链接上的微信code，获取前需要去掉原来的code
    getWxcode() {
      // let href = window.encodeURI(this.removeURLParameter(window.location.href, 'code'));
      let u = this.removeURLParameter(window.location.href, ['code'])
      u = this.removeURLParameter(u, ['state'])
      let href = window.encodeURIComponent(u)
      console.log(1, href)
      // let newurl = window.encodeURIComponent(window.location.pathname + window.location.search)
      let n = this.removeURLParameter(window.location.pathname + window.location.search, ['code'])
      n = this.removeURLParameter(n, ['state'])
      let newurl = window.encodeURIComponent(n)
      console.log(2, newurl)

      var appid = "wxa4d612a11ba4e9b8";
      console.log(3, `https://app.gaokaozhitongche.com/wx/index?appid=${appid}&redirect_uri=${href}&response_type=code&scope=snsapi_base&state=${newurl}#wechat_redirect`)
      // return
      window.location.href = `https://app.gaokaozhitongche.com/wx/index?appid=${appid}&redirect_uri=${href}&response_type=code&scope=snsapi_base&state=${newurl}#wechat_redirect`;

      // var openid = Cookie.getCookie('openId')
      // console.log('openid',openid)
      // if(openid){
      //   window.location.href = `https://app.gaokaozhitongche.com/wx/index?appid=${appid}&redirect_uri=${href}&response_type=code&scope=snsapi_base&state=${newurl}#wechat_redirect`;
      // }else{
      //   window.location.href = `https://app.gaokaozhitongche.com/wx/index?appid=${appid}&redirect_uri=${href}&response_type=code&scope=snsapi_userinfo&state=${newurl}#wechat_redirect`;
      // }
    },
    // 去掉url的指定参数方法
    removeURLParameter(url, parameter) {
      var urlparts = url.split('?');
      if(urlparts.length >= 2) {
        //参数名前缀
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);
    
        //循环查找匹配参数
        for(var i = pars.length; i-- > 0;) {
          if(pars[i].lastIndexOf(prefix, 0) !== -1) {
            //存在则删除
            pars.splice(i, 1);
          }
        }
    
        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
      }
      return url;
    },
    // 获取链接上的微信授权code
    getCode() {
      if (!window.location.search) return false;
      let query = window.location.search.split("?")[1].split("&");
      for (let x in query) {
        if (query[x].indexOf("=") === -1) continue;
        if (query[x].split("=")[0] === "code") return query[x].split("=")[1];
      }
      return false;
    },
    getCookieInfo() {
      console.log('cookie 的 info', getCookieToken(), getCookieUid())
      return getCookieToken() && getCookieUid()
    }
    // 已经弃用的方法，因为v2登录不需要先获取token再去登录，而是登录成功后才返回token
  //   getToken(callback) {
  //     Http.post(OAUTH2_TOKEN, {
  //       client_id: "gkztcweb",
  //       client_secret: "web4gkztc",
  //       grant_type: "client_credentials",
  //       uid: "",
  //       refresh_token: ""
  //     }).then(res => {
  //       if (res.code == 0) {
  //         var data = res.data;
  //         data.expires_in =
  //           parseInt(new Date().getTime() / 1000) + res.data.expires_in;
  //         // this.loginInfo = data;
  //           // this.$store.commit("setLoginInfo", {
  //           //   access_token: data.access_token,
  //           //   uid: 
  //           // });
  //         localStorage["loginInfo"] = JSON.stringify(data);
  //         callback&&callback(res.data.access_token, this.getCode());
  //       }
  //     });
  //   }
  }
};
</script>
<style lang="scss">
.el-loading-mask{
  // z-index: 999999 !important;
}
.van-toast {
  z-index: 999999 !important;
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
// 登录
.login-shadow {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  max-width: 768px;
  background: #000;
  opacity: 0.6;
  z-index: 9999;
  
}
.login-box {
  width: 17.15rem;
  // height: 11rem;
  padding: 1.5rem 1rem 1.2rem 1rem;
  border-radius: 0.5rem;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  .img-close {
    display: block;
    width: 1.5rem;
    height: 1.5rem;
    position: absolute;
    right: 0;
    top: -2rem;
  }
  .logo {
    width: auto;
    height: 2.4rem;
    display: block;
    margin: 0 auto 1rem auto;
  }
  .title {
    font-size: 0.8rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: bold;
    color: #333333;
    margin-bottom: 0.8rem;
    text-align: center;
  }
  .input-box {
    width: 14rem;
    height: 2.4rem;
    margin: 0 auto;
    position: relative;
    line-height: 2.4rem;
    border-bottom: 1px solid #f6f6f6;
    span {
      display: block;
      width: 4.6rem;
      height: 1.5rem;
      font-size: 0.65rem;
      line-height: 1.5rem;
      text-align: center;
      border: 1px solid #ccc;
      border-radius: 0.75rem;
      border: 0.05rem solid #2382FF;
      position: absolute;
      right: 0;
      top: 0.25rem;
      color: #2382FF;
    }

    .gray {
      border-color: #EDEDED;
      color: #999999 ;
    }
  }
  input {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
    outline: 0;
    text-align: left;
    font-size: 0.65rem;
    color: #666;
  }
  .login-btn {
    width: 14rem;
    height: 2.2rem;
    margin: 0 auto;
    font-size: 0.75rem;
    line-height: 2.2rem;
    text-align: center;
    color: #fff;
    font-weight: bold;
    background: linear-gradient(90deg, #2382FF 0%, #4BB9FE 100%);
    border-radius: 1.2rem;
    margin-top: 1rem;
    opacity: 0.5;
  }
  .canpress{
    opacity: 1;
  }
}
</style>
